import { render } from "./TheDemandHeader.vue?vue&type=template&id=c8ae589e&scoped=true"
import script from "./TheDemandHeader.vue?vue&type=script&lang=js"
export * from "./TheDemandHeader.vue?vue&type=script&lang=js"

import "./TheDemandHeader.vue?vue&type=style&index=0&id=c8ae589e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c8ae589e"

export default script